/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const InDigestMultibase: core.serialization.ObjectSchema<
    serializers.InDigestMultibase.Raw,
    Truvity.InDigestMultibase
> = core.serialization.object({
    values: core.serialization.list(core.serialization.string()),
});

export declare namespace InDigestMultibase {
    export interface Raw {
        values: string[];
    }
}
